import store from "@/store";
import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";
import "firebase/firestore";

const appData = {
  dev: {
    apiKey: "AIzaSyAN7MJ0IDTN6-N37ca0nEBEm6a3m-J7yT4",
    authDomain: "heartbeatfamdev.firebaseapp.com",
    projectId: "heartbeatfamdev",
    storageBucket: "heartbeatfamdev.appspot.com",
    messagingSenderId: "19335738204",
    appId: "1:19335738204:web:8be07d94d8f80cf5f30799",
    measurementId: "G-BTMY5MGJKK"
  },
  prod: {
    apiKey: "AIzaSyC4x-BVkPDTKANbztNJZdkd8o6jO0A_wiM",
    authDomain: "derriana.firebaseapp.com",
    projectId: "derriana",
    storageBucket: "derriana.appspot.com",
    messagingSenderId: "193773025131",
    appId: "1:193773025131:web:ccdd3b49ee5bdfaf187e2e",
    measurementId: "G-DDGNVHDLZH"
  }
};
let firebaseApp = firebase.initializeApp(appData.prod);

firebase.analytics();

export default {
  install: (Vue, options) => {
    const auth = firebaseApp.auth();
    auth.onAuthStateChanged(user => {
      store.commit("user/UPDATE_USER", { user });
      if (user) {
        store.dispatch("user/getUserDeviceRegistrationToken");
      }
    });
  }
};
